import { IconProps } from './icons';

export const MapIcon = ({ color = '#0085FF', height = 51, width = 50 }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 51 50" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.25 41.085L19.3544 46.021L34.1635 37.7246L46.75 42.6605V9.00624L33.8366 3.94214L18.8956 12.3124L4.25 7.52625V41.085ZM29.75 35.3982L21.25 40.1601V15.7924L29.75 11.0305V35.3982ZM34 33.1729L42.5 36.5062V11.8272L34.1634 8.55797L34 8.64953V33.1729ZM8.5 38.0818L17 40.8596V16.085L8.5 13.3072V38.0818Z"
        fill={color}
      />
    </svg>
  );
};
